import { render, staticRenderFns } from "./SmsPrice.vue?vue&type=template&id=013579d1&"
import script from "./SmsPrice.vue?vue&type=script&lang=js&"
export * from "./SmsPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports